export default (state = {}) => ({
    ...state,
    categories: state.categories || []
});
